import axios from 'axios';

// API基础URL配置
const config = {
    // 开发环境
    development: {
        apiBaseUrl: 'http://localhost:5001'
    },
    // 生产环境
    production: {
        apiBaseUrl: window.location.protocol + '//' + window.location.host + '/hou'  // 使用相对路径，自动适应协议和域名
    }
};

// 根据当前环境返回相应的配置
const env = process.env.NODE_ENV || 'development';
const currentConfig = config[env];

// 配置 axios 默认值
axios.defaults.withCredentials = true;  // 允许跨域请求携带 cookies

export default currentConfig; 